<template>
    <div>
        <Card>
            <div class="d-flex justify-content-end">
                <div class="col-3 p-2">
                    <Input placeholder="Search by training name" type="text" v-model="trainingSearchTerm" />
                </div>
            </div>
            <hr class="my-0 mb-2" />
            <!-- <div v-if="!trainingList">
                <loader-component></loader-component>
            </div> -->
            <div v-if="checkTrainingSearch">
                <div class="row">
                    <div class="col-3 mb-3" v-for="(training, index) in trainingListByOnlyTraining" :key="index">
                        <Card class="p-3 m-0">
                            <img :src="training.trainingImg" v-if="training.trainingImg" class="training-img" />
                            <img
                                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ8Fb0JfnooRfkiWm-ZNiYcNVs0_pnHZCfdFqaDuaq2swumeP49LZdT4I0fovUIq7CbM0k&usqp=CAU"
                                v-else
                                class="training-img"
                            />
                            <div class="">
                                <p class="my-0 course-title" v-tooltip="training.name">{{ training.name }}</p>
                                <!-- <div class="d-flex justify-content-between"> -->
                                <Badge
                                    class="badge-rounded badge-rounded-grey-outline my-2"
                                    :label="training.trainingSessions.length + ' Days'"
                                />
                                <br />
                                <Button
                                    :class="[
                                        'qb-btn',
                                        { 'qb-btn-grey-sm': training.isEnrolled },
                                        {
                                            'qb-btn-primary-sm': !training.isEnrolled,
                                        },
                                        'mt-2',
                                        'w-100',
                                    ]"
                                    @onClick="handleNavigation({ id: training.id, isEnrolled: training.isEnrolled })"
                                    :label="training.isEnrolled ? 'View Training' : 'Enroll Training'"
                                />
                                <!-- </div> -->
                            </div>
                        </Card>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="mb-3" v-for="(category, index) in trainingList" :key="index">
                    <div v-if="category.trainings.length > 0">
                        <p class="category-title ms-3 mt-3 mb-2">{{ category.categoryName }}</p>
                        <div class="row m-0">
                            <div class="col-3 mb-3" v-for="(training, index) in category.trainings" :key="index">
                                <Card class="p-3 m-0">
                                    <img :src="training.trainingImg" v-if="training.trainingImg" class="training-img" />
                                    <img
                                        src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ8Fb0JfnooRfkiWm-ZNiYcNVs0_pnHZCfdFqaDuaq2swumeP49LZdT4I0fovUIq7CbM0k&usqp=CAU"
                                        v-else
                                        class="training-img"
                                    />
                                    <div class="">
                                        <p class="my-0 course-title" v-tooltip="training.name">{{ training.name }}</p>
                                        <!-- <div class="d-flex justify-content-between"> -->
                                        <Badge
                                            class="badge-rounded badge-rounded-grey-outline my-2"
                                            :label="training.trainingSessions.length + [training.trainingSessions.length==1 ? ' Day' : ' Days']"
                                        />
                                        <br />
                                        <Button
                                            :class="[
                                                'qb-btn',
                                                { 'qb-btn-primary-sm': training.isEnrolled },
                                                {
                                                    'qb-btn-primary-sm': !training.isEnrolled,
                                                },
                                                'mt-2',
                                                'w-100',
                                            ]"
                                            @onClick="
                                                handleNavigation({ id: training.id, isEnrolled: training.isEnrolled })
                                            "
                                            label="View"
                                        />
                                        <!-- </div> -->
                                    </div>
                                </Card>
                            </div>
                            <!--  -->
                            <div
                                class="col-2 mx-auto"
                                v-if="
                                    category.totalTrainings > 4 && category.totalTrainings !== category.trainings.length
                                "
                            >
                                <div class="show-more-container" @click="paginationHandler(category.categoryId)">
                                    Show More <font-awesome-icon icon="fa-solid fa-angle-down" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Card>
    </div>
</template>

<script>
// import LoaderComponent from "../components/LoaderComponent.vue"
import Button from '../components/ButtonComponent.vue';
import Badge from '../components/BadgeComponent.vue';
import Input from '../components/TextFieldComponent.vue';
// import DropDown from "../components/DropDownSearchComponent.vue";
import Card from '../components/CardComponent.vue';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters: trainingMapGetters, mapActions: trainingMapActions } = createNamespacedHelpers('Training');

export default {
    name: 'TrainingPage',
    data() {
        return {
            trainingSearchTerm: '',
            pagination: [],
            size: 4,
        };
    },
    components: {
        Card,
        Input,
        // DropDown,
        Badge,
        Button,
        // LoaderComponent
    },
    computed: {
        ...trainingMapGetters({
            trainingList: 'getTrainingList',
            totalTraining: 'getTotalTrainingCount',
            trainingListByOnlyTraining: 'getTrainingListByOnlyTraining',
        }),
        checkTrainingSearch() {
            return this.$route.query.searchTerm;
        },
    },
    methods: {
        ...trainingMapActions({
            getTrainingList: 'GET_TRAINING_LIST',
            getTrainingListByCategory: 'GET_TRAINING_LIST_BY_CATEGORY',
            getTrainingListByOnlyTraining: 'GET_TRAINING_LIST_BY_ONLY_TRAINING',
        }),
        handleNavigation({ id = '123', isEnrolled }) {
            if (isEnrolled) {
                this.$router.push({ name: 'WorkSheetPage', params: { id: isEnrolled } });
            } else {
                this.$router.push({ name: 'TrainingDescriptionPage', params: { id } });
            }
        },
        handleTrainingNavigation(name) {
            this.$router.push({ name });
        },
        paginationHandler(categoryId) {
            let tempPageNo = 1;
            const foundedPage = this.pagination.find((item) => item.categoryId === categoryId);
            if (foundedPage) {
                tempPageNo += foundedPage.page;
                foundedPage.page += 1;
            } else {
                tempPageNo = 2;
                this.pagination.push({
                    categoryId,
                    page: 2,
                });
            }

            this.getTrainingListByCategory({ categoryId, page: tempPageNo, size: this.size });
        },
    },
    watch: {
        trainingSearchTerm(name) {
            if (this.trainingSearchTerm) {
                this.$router.push({ name: 'TrainingPage', query: { searchTerm: name } });
                this.getTrainingListByOnlyTraining({ name });
            } else {
                this.$router.push({ name: 'TrainingPage' });
                this.getTrainingList({ categoryPage: 1 });
            }
        },
    },
    created() {
        this.getTrainingList({ categoryPage: 1 });
        if (this.checkTrainingSearch) {
            this.trainingSearchTerm = this.$route.query.searchTerm;
            this.getTrainingListByOnlyTraining({ name: this.$route.query.searchTerm });
        }
    },
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/color.scss';
@import '../assets/scss/font.scss';
@import '../assets/scss/field.scss';

.fa-users-rectangle {
    font-size: 30px;
    margin: auto;
}
.category-title {
    font-size: $font-size-xxxl;
    font-weight: $font-weight-bold;
    color: $dark-100;
    text-transform: capitalize;
}
.course-title {
    font-size: $font-size-xxl;
    font-weight: $font-weight-normal-2;
    text-overflow: ellipsis;
    display: block;
    width: 250px;
    overflow: hidden;
    white-space: nowrap;
}
.catalogue-card {
    border-radius: $field-border-radius;
    border: 1px solid $light-300;
}
.course-img {
    border-radius: $field-border-radius;
    background-color: $light-300;
    width: 100px;
    height: 100px;
}

.training-img {
    width: 100%;
    min-height: 165px;
    max-height: 100px;
    border-radius: $field-border-radius;
}

.show-more-container {
    font-size: $font-size-md;
    font-weight: $font-weight-bold;
    color: $primary-100;
    text-align: center;
    margin: auto;
    padding: 5px;
    cursor: pointer;
    border: 1px solid $light-300;
    border-radius: $field-border-radius;
}
</style>
